module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--procedures@2x-7111a434f48f53c1d7184cbca4cfdf67.jpg";